module.exports = __webpack_public_path__ + "img/icon-home.7292a060.svg";